import { ChevronRightIcon } from '@heroicons/react/24/outline';
import PremiumIconCrown from './PremiumIconCrown';
import PremiumOfferCta from './PremiumOfferCta';
import TrialCountdownText from './TrialCountdownText';
import { usePremiumOffer } from '../contexts/premiumOffer';
import { GET_PREMIUM_ACCESS_URL } from '../utils/isPremiumUser';

// Reusable crown "card" for the export menus (header export dropdown + block
// activity export submenu). Crown + message + an inline CTA on the same flow;
// the whole card is clickable and opens the plans page. `mode` selects the
// free-user upsell vs the trial countdown so both states render an identical
// card in either menu.
//
// A teacher who still has the 30-day extension to claim gets the offer instead, and then the
// card stops being one big button: the offer and the plans link are two separate targets, and
// nesting them inside a button would be invalid markup with an unpredictable click target.
const ExportUpsellCard = ({ mode, location, trackEvent, freeHeading = 'Need premium access?' }) => {
  const isTrial = mode === 'trial';
  const { isOffered } = usePremiumOffer();

  if (isOffered) {
    return (
      <div className='w-full bg-gray-50 flex items-center px-4 py-3 rounded-md'>
        <PremiumOfferCta
          variant='inline'
          // A trial teacher still needs to know how long they have; the offer replaces the
          // plans link, not the countdown that sits in front of it.
          question={isTrial ? <TrialCountdownText /> : freeHeading}
          location={location}
        />
      </div>
    );
  }

  return (
    <button
      className='w-full bg-gray-50 text-left hover:bg-gray-100 flex items-center group px-4 py-3 rounded-md'
      onClick={() => {
        trackEvent(isTrial ? 'See Plans Clicked' : 'Get Premium Access Clicked', { location });
        window.open(GET_PREMIUM_ACCESS_URL, '_blank');
      }}>
      <PremiumIconCrown
        className='h-6 w-6'
        wrapperClassName='flex-shrink-0'
        toolTipProps={{ text: undefined, position: 'bottom', anchor: 'left' }}
      />
      <span className='ms-3 me-2 flex-1 min-w-0 text-xs text-gray-900 whitespace-normal'>
        {isTrial ? <TrialCountdownText /> : <span>{freeHeading}</span>}{' '}
        <span className='text-amber-700 font-medium whitespace-nowrap'>
          See Plans
          <ChevronRightIcon className='inline-block h-3 w-3 align-text-bottom' />
        </span>
      </span>
    </button>
  );
};

export default ExportUpsellCard;
